import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useParams } from "react-router";
import { SplitPane } from "react-collapse-pane";
import swal from "sweetalert";
import { toast } from 'react-toastify';
import { Navbar } from "../../Components/Navbar";
import TbcHeader from "../Components/TBC/TbcHeader";
import { useDispatch, useSelector } from "react-redux";
import { getBCTbRows } from "../../redux/actions/BookClosure/actionBookClosure";
import Loader from "../../helper/loader";
import TbcTableData from "../Components/TBC/TbcTableData";
import TemplateTab from "../Components/TBC/TemplateTab";
import { motion } from "framer-motion";

import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"


const Tbc = () => {
  const { bookClosureTbId } = useParams();
  const dispatch = useDispatch();

  const {
    lineItems,
    groupings,
    filters,
    loading,
    errorMessage,
    error
  } = useSelector((initialState) => initialState.BookClosureTbcReducer);
  
  useEffect(() => {
    dispatch(getBCTbRows(bookClosureTbId));
  }, [dispatch, bookClosureTbId]);

  const [allLineItems, setAllLineItems] = useState([]); // original unfiltered
  const [filteredLineItems, setFilteredLineItems] = useState([]); // filtered
  const [deletedLedgers, setDeletedLedgers] = useState([])

  const [dragData, setDragData] = useState({});

  useEffect(() => {
    if (lineItems?.length > 0) {
      setAllLineItems(lineItems);       // store original
      setFilteredLineItems(lineItems);  // initially show all

      const deleted = lineItems.filter(item => item.deleted === true);
      setDeletedLedgers(deleted);
    }
  }, [lineItems]);
  
  const [searchText, setSearchText] = useState("");
 

  return (
    <React.Fragment>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <div className={commoncss.w100} style={{ maxHeight: "100vh", overflowY: "hidden" }} >
            <TbcHeader 
              allLineItems={allLineItems}
              setFilteredLineItems={setFilteredLineItems}
              lineItems={filteredLineItems} currentMode="2"
              searchText={searchText}
              setSearchText={setSearchText}
              deletedLedgers={deletedLedgers}
            />
            <motion.div
              initial={{ x: -100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: 0, opacity: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}>
              <div
                className="tabsinside"
                style={{ maxHeight: "95vh", overflow: "hidden" }}
              >
                <SplitPane
                  minSizes={[600, 300]}
                  initialSizes={[50, 50]}
                  split="vertical"
                  collapseOptions={{
                    beforeToggleButton: <Button>⬅</Button>,
                    afterToggleButton: <Button>➡</Button>,
                    overlayCss: { backgroundColor: "black" },
                    buttonTransition: "zoom",
                    buttonPositionOffset: -20,
                    collapsedSize: 50,
                    collapseTransitionTimeout: 350,
                  }}
                  resizerOptions={{
                    css: {
                      width: "1px",
                      background: "#03565ade"
                    },
                    hoverCss: {
                      width: "5px",
                      background: "4px solid rgba(0, 0, 0)",
                    },
                    grabberSize: "5px",
                  }}
                >
                  <div className="h-100">
                    <div style={{ overflow: "auto", height: "100%" }}>
                      {loading ? (
                        <Loader />
                      ) : error ? (
                        <p className="d-flex justify-content-center align-items-center h-100 text-danger">
                          {errorMessage}
                        </p>
                      ) : (
                        <TbcTableData setDragData={setDragData} lineItems={filteredLineItems.length > 0 ? filteredLineItems : []} searchText={searchText }/>
                      )}
                    </div>
                  </div>

                  <div style={{ maxHeight: "95vh", overflowY: "scroll" }}>
                    <TemplateTab dragData={dragData} bookClosureTbId={bookClosureTbId}/>
                  </div>
                </SplitPane>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default React.memo(Tbc);
